module.exports = __webpack_public_path__ + "static/media/ednaClyde88.6db7ae69.png";